// @flow
import type { Action } from "../action";

type State = boolean;

function switchDeposit(payload: Object) {
  switch (payload.value) {
    case 1:
      return true;
    case 0:
    default:
      return false;
  }
}

function iOSShowDeposit(state: State = false, action: Action): State {
  switch (action.type) {
    case "RECEIVE_IOS_SHOW_DEPOSIT":
      return switchDeposit(action.payload);
    default:
      return state;
  }
}

export default iOSShowDeposit;



// WEBPACK FOOTER //
// ./src/redux/reducer/iOSShowDeposit.js